/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState } from 'react';
import { useSpring } from 'react-spring';
import { isNullOrEmptyArray } from '../../util/arrays';
import { Loading } from '../Loading';
import * as Ui from './styles';


const SUBITEM_MIN_HEIGHT = 28;

/**
 * Componente que possibilita criar uma listagem de itens selecionáveis, bem como a si mesmo.
 * Exemplo de uso.
 *
 * <CollapsibleList
 *   title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"
 *   checkedTitle={true}
 *   boldedTitle={false}
 *   multCheck={true}
 *   collapsed={false}
 *   data={[
 *     {value: 1, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 2, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 3, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 4, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 5, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 6, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *     {value: 7, label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In maximus"},
 *   ]}
 *   selectedValues={[2, 7]}
 * />
 * @param {*} param0
 */
function CollapsibleListComp({
  id,
  index,
  // título da lista
  title,
  // define se o componente é expansível, caso não seja o comportamento de clique será igual ao de seleção
  expansible = true,
  // define se o título está recolhido
  collapsed = true,
  // define se o título está selecionado
  checkedTitle = false,
  // define se o título tem destaque
  boldedTitle = false,
  // define um tooltip para o título
  tooltipTitle,
  // define se o componente possui comportamento de multiseleção
  multCheck = false,
  // define se os itens podem ser checados
  checkable = true,
  // define se apresenta um loading ao invés de dados quando o componente estiver expandido
  loading = false,
  // destaque o item em foco
  highlightFocusItem = false,
  // dados a serem apresentados.Ex.: [{value: 1, label: "Lorem ipsum dolor"}]
  data = [],
  // valores selecionados [1, 2, ...]
  selectedValues = [],
  // evento de propagação de seleção do título
  onSelectTitle,
  // evento de propagação da ação de expandir
  onExpand,
  // evento de propagação da ação de retrair
  onCollapse,
  // evento de propagação de alteração da listagem de seleção
  onChangeSelectedItems,
  // define se a seta ira aparecer
  withArrow = true,
  // define se o item sera exibido em letras maiusculas
  isUpperCase = true,
  // define o padding do texto
  textPadding,
  // controla a exibição de checkbox das perguntas
  hiddenCheckboxCollapsibleQuestion = false
}) {
  // states
  const [initialData, setInitialData] = useState([]);
  const [initialSelectedValues, setInitialSelectedValues] = useState([]);
  const [internalSelectedValues, setInternalSelectedValues] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemsSet, setItemsSet] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const [bodyVisibility, setBodyVisibility] = useState(!collapsed);
  const dataGroupQt = loading ? 3 : Math.round(data.length / 3) + 1;

  // callbacks
  const setSelectedItemsProxy = useCallback((items) => {
    const values = items.map((i) => i.value);
    setSelectedItems(items);
    setInternalSelectedValues(values);
  }, []);

  // effect of change list data
  useEffect(() => {
    if (!isNullOrEmptyArray(data)) {
      setInitialData(data);
    }
  }, [data]);

  // effect of change selected values
  useEffect(() => {
    if (!isNullOrEmptyArray(selectedValues)) {
      setInitialSelectedValues(selectedValues);
    }
  }, [selectedValues]);

  // efeito de definir os itens selecionados
  useEffect(() => {
    if (isNullOrEmptyArray(initialData)) return;
    // cria um vetor de itens selecionados
    const sel = initialData.filter((item) => initialSelectedValues.includes(item.value));
    // atribui estes itens no estado do componente
    setSelectedItemsProxy(sel);
  }, [initialData, initialSelectedValues, setSelectedItemsProxy]);

  // efeito de definir os itens selecionados
  useEffect(() => {
    //
    if (isNullOrEmptyArray(initialData)) return;
    // checker
    function wasSelected(value) {
      return internalSelectedValues.includes(value);
    }
    // cria um vetor de itens selecionados
    const items = initialData.map((item) => ({ ...item, checked: wasSelected(item.value) }));
    // atribui estes itens no estado do componente
    setItemsSet(items);
  }, [initialData, internalSelectedValues]);

  // collapse or expand
  const collapseAnimation = useSpring({
    config: { duration: 100 },
    from: {
      height: isCollapsed ? `${dataGroupQt * SUBITEM_MIN_HEIGHT + 5}px` : '0px',
    },
    to: {
      height: isCollapsed ? '0px' : `${dataGroupQt * SUBITEM_MIN_HEIGHT + 5}px`,
    },
    onStart: () => {
      if (!isCollapsed) setBodyVisibility(true);
    },
    onRest: () => {
      if (isCollapsed) setBodyVisibility(false);
    },
  }, [isCollapsed]);

  //
  function toogleTitle() {
    if (boldedTitle) return;
    const selected = !checkedTitle;
    if (onSelectTitle) onSelectTitle(selected, index);
  }

  //
  function checkItem(item) {
    // recria o vetor de itens selecionas e adiciona item
    const { value, label } = item;
    const sel = [...selectedItems, { value, label }];
    // atribui estes itens no estado do componente
    setSelectedItemsProxy(sel);
    // propaga o evento de seleção
    if (onChangeSelectedItems) onChangeSelectedItems(sel);
    // ao selecionar item em caso de não estar selecionado
    if (!checkedTitle) {
      toogleTitle();
    }
  }

  function uncheckItem(item) {
    // recria o vetor de itens selecionas e adiciona item
    const sel = selectedItems.filter((si) => si.value !== item.value);
    // atribui estes itens no estado do componente
    setSelectedItemsProxy(sel);
    // propaga o evento de seleção
    if (onChangeSelectedItems) onChangeSelectedItems(sel);
    // remove a seleção caso nenhum item esteja selecionado
    if (checkedTitle && isNullOrEmptyArray(internalSelectedValues)) {
      toogleTitle();
    }
  }

  function checkOrUncheckItem(item) {
    // verifica se já está selecionado
    if (internalSelectedValues.includes(item.value)) {
      uncheckItem(item);
    } else {
      checkItem(item);
    }
  }

  function clearAndCheckItem(item) {
    // define o novo vetor de selecionados
    const { value, label } = item;
    let sel = [{ value, label }];
    if(!!selectedItems[0]){
      sel = selectedItems[0].value === value ? [] : sel;
    }
    // ignora os itens existentes e adiciona o último selecionado
    setSelectedItemsProxy(sel);
    // propaga o evento de seleção
    if (onChangeSelectedItems) onChangeSelectedItems(sel);
    // ao selecionar qualq
    if (!checkedTitle) {
      toogleTitle();
    }
  }

  function handleSelectItem(item) {
    // verifica se é possível selecinar itens
    if (!checkable) return;
    // verifica qual o tipo de seleção (mult ou single)
    if (multCheck) {
      checkOrUncheckItem(item);
    } else {
      clearAndCheckItem(item);
    }
  }

  function handleSelectTitle() {
    if (checkedTitle) {
      // remove todas as seleções
      setSelectedItemsProxy([]);
      // propaga o evento de seleção vazia
      if (onChangeSelectedItems) onChangeSelectedItems([]);
    }
    //
    toogleTitle();
  }

  /**
   * A manipulação do toque no título será
   * igual ao de selecionar o título se o componente for não expansível.
   * Caso contrário, ele irá verificar se há itens e expandir para mostrar
   */
  function handleCollapse() {
    if (!expansible) handleSelectTitle();
    else {
      setIsCollapsed(!isCollapsed);
      if (isCollapsed) {
        // {label: string : checked: boolean, value:'algo de valor unico'}
        if (onExpand) onExpand({ label: title, checkedTitle, value: id }, index);
      } else if (onCollapse) onCollapse();
    }
  }

  // renders: loading
  function renderLoadingSpinner() {
    return (
      <Ui.ItemsEmpty>
        <Loading size={30} running={loading} />
      </Ui.ItemsEmpty>
    );
  }

  const ItemWrapper = (wrappedProps) => (checkable ? (
    <Ui.Item {...wrappedProps} />
  ) : (
    <Ui.FixedItem {...wrappedProps} />)
  );

  return (
    <Ui.Container
      isChecked={checkedTitle}
      isCollapsed={isCollapsed}
      title={tooltipTitle}
      className="CollapsibleList"
      highlightFocusItem={highlightFocusItem}
    >
      <Ui.Head  isCollapsed={isCollapsed} textPadding={textPadding}>
       {!hiddenCheckboxCollapsibleQuestion && (
          <Ui.CircleWrapper clear isBolded={boldedTitle} onClick={() => handleSelectTitle()}>
            <Ui.Circle size={15} isBolded={boldedTitle} isChecked={checkedTitle} />
          </Ui.CircleWrapper>
       )}
        <Ui.Collapser clear onClick={() => handleCollapse()}>
          {
            withArrow && <Ui.Arrow size={18} color={'#610082'} isChecked={checkedTitle} />
          }
          {/* TODO: (victor, resolver) Removido pois estava comprometendo a performance e fugindo do design do resto dos tooltips */}
          {/* {tooltipTitle ? (
            <Ui.TextWithHint isBolded={boldedTitle} tooltip={tooltipTitle}>
              {title}
            </Ui.TextWithHint>
          ) : (
            <Ui.Title isBolded={boldedTitle} title={tooltipTitle}>{title}</Ui.Title>
          )} */}
          <Ui.Title isBolded={boldedTitle} isUpperCase={isUpperCase} title={title}>{title}</Ui.Title>
        </Ui.Collapser>
      </Ui.Head>
      <Ui.Body style={{ ...collapseAnimation, display: bodyVisibility ? 'flex' : 'none' }}>
        {loading && !isCollapsed ? renderLoadingSpinner() : (
          <Ui.Items isOpen={!isCollapsed}>
            {itemsSet.map((item) => (
              <ItemWrapper key={`id-${item.value}`} clear onClick={() => handleSelectItem(item)}>
               {hiddenCheckboxCollapsibleQuestion && <Ui.CircleItem size={15} isChecked={item.checked} isBolded={boldedTitle} />}
                <Ui.Text title={item.label}>{item.label}</Ui.Text>
              </ItemWrapper>
            ))}
          </Ui.Items>
        )}
      </Ui.Body>
    </Ui.Container>
  );
}

export const CollapsibleList = React.memo(CollapsibleListComp);
